import * as React from 'react';
import { createComponent } from '@lit/react';
import type { EventName } from '@lit/react';
import { Accordion as SpAccordion } from '@spectrum-web-components/accordion';
import { AccordionItem as SpAccordionItem } from '@spectrum-web-components/accordion';

import '@spectrum-web-components/accordion/sp-accordion-item.js';
import '@spectrum-web-components/accordion/sp-accordion.js';

export const Accordion = createComponent({
    displayName: 'Accordion',
    elementClass: SpAccordion,
    react: React,
    tagName: 'sp-accordion',
    events: {},
});
export const AccordionItem = createComponent({
    displayName: 'AccordionItem',
    elementClass: SpAccordionItem,
    react: React,
    tagName: 'sp-accordion-item',
    events: {
        spAccordionItemToggle:
            'sp-accordion-item-toggle' as EventName<CustomEvent>, // Announce that an accordion item has been toggled while allowing the event to be cancelled.
    },
});

export type AccordionType = EventTarget & SpAccordion;
export type AccordionItemType = EventTarget & SpAccordionItem;
